// extracted by mini-css-extract-plugin
module.exports = {"toaster":"Toaster_toaster__RtYlt","copy-toast":"Toaster_copy-toast__x6eA4","list":"Toaster_list__QTc8W"};